import React, { useEffect, useState } from "react";
import { collection, query, where, getDocs, addDoc } from "firebase/firestore";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import Modal from "react-modal"; // Install with `npm install react-modal`
import "./PayoutHistory.css";
import { db } from "../../FirebaseConfig";

Modal.setAppElement("#root");

const PayoutHistory = () => {
  const [user, setUser] = useState({});
  const [balance, setBalance] = useState(0);
  const [payouts, setPayouts] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [withdrawAmount, setWithdrawAmount] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      const auth = getAuth();

      onAuthStateChanged(auth, async (currentUser) => {
        if (currentUser) {
          // Fetch user data
          const userRef = collection(db, "influencers");
          const userQuery = query(userRef, where("uid", "==", currentUser.uid));
          const userSnapshot = await getDocs(userQuery);

          if (!userSnapshot.empty) {
            const currentUserData = userSnapshot.docs[0].data();
            setUser(currentUserData);
            setBalance(currentUserData.amount || 0);

            // Fetch payouts
            const payoutsQuery = query(
              collection(db, "payouts"),
              where("uid", "==", currentUser.uid)
            );
            const payoutsSnapshot = await getDocs(payoutsQuery);
            const payoutData = payoutsSnapshot.docs.map((doc) => ({
              ...doc.data(),
              id: doc.id,
            }));
            setPayouts(payoutData);
          }
        }
      });
    };

    fetchData();
  }, []);

  const handleWithdraw = async (e) => {
    e.preventDefault();
    if (withdrawAmount <= 0 || withdrawAmount > balance) {
      alert("Invalid withdrawal amount!");
      return;
    }

    const newPayout = {
      uid: user.uid,
      amount: parseFloat(withdrawAmount),
      status: "pending",
      requestedAt: new Date().toISOString(),
    };

    try {
      await addDoc(collection(db, "payouts"), newPayout);
      setBalance((prevBalance) => prevBalance - withdrawAmount);
      setPayouts((prevPayouts) => [newPayout, ...prevPayouts]);
      setIsModalOpen(false);
      alert("Withdrawal request submitted successfully!");
    } catch (error) {
      console.error("Error submitting withdrawal request:", error);
    }
  };

  return (
    <div className="payout-history">
      {/* Balance Info */}
      <div className="balance-section">
        <h2>Available Balance: £{balance.toFixed(2)}</h2>
        {balance >= 50 && (
          <button className="withdraw-btn" onClick={() => setIsModalOpen(true)}>
            Withdraw
          </button>
        )}
      </div>

      {/* Payout History Table */}
      <div className="payout-table">
        <h3>Your Payouts</h3>
        <table>
          <thead>
            <tr>
              <th>Amount</th>
              <th>Status</th>
              <th>Requested At</th>
            </tr>
          </thead>
          <tbody>
            {payouts.length > 0 ? (
              payouts.map((payout) => (
                <tr key={payout.id}>
                  <td>£{payout.amount.toFixed(2)}</td>
                  <td>{payout.status}</td>
                  <td>{new Date(payout.requestedAt).toLocaleDateString()}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3">No payouts found.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Withdrawal Modal */}
      <Modal
        isOpen={isModalOpen}
        onRequestClose={() => setIsModalOpen(false)}
        className="withdraw-modal"
        overlayClassName="modal-overlay"
      >
        <h2>Request Withdrawal</h2>
        <form onSubmit={handleWithdraw}>
          <label htmlFor="withdrawAmount">Amount:</label>
          <input
            type="number"
            id="withdrawAmount"
            value={withdrawAmount}
            onChange={(e) => setWithdrawAmount(e.target.value)}
            min="50"
            max={balance}
          />
          <button type="submit">Submit</button>
          <button type="button" onClick={() => setIsModalOpen(false)}>
            Cancel
          </button>
        </form>
      </Modal>
    </div>
  );
};

export default PayoutHistory;
